import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { InputChips, TextField, useChipCollection } from '@fs/zion-ui'

export default function MultiTextField({
  initialValues,
  label,
  name,
  onBlurTextField,
  onFocusTextField,
  onUpdateValues,
  ...props
}) {
  const chipCollection = useChipCollection(initialValues?.map((value) => ({ label: value, value })))
  const onUpdateValuesRef = useRef(onUpdateValues)
  const [editingChip, setEditingChip] = useState()
  const [textFieldValue, setTextFieldValue] = useState('')

  const { addChip, chips, removeChip } = chipCollection

  useEffect(() => {
    onUpdateValuesRef.current?.(chips)
  }, [chips])

  function handleClick(_event, item) {
    setEditingChip(item)
    setTextFieldValue(item.value)
  }

  function handleEnter({ target: { value } }) {
    if (editingChip) {
      removeChip(editingChip)
      setEditingChip(null)
    }

    addChip({ label: value, value })
    setTextFieldValue('')
  }

  return (
    <div>
      <TextField
        label={label}
        name={name}
        onBlur={onBlurTextField}
        onChange={({ target: { value } }) => setTextFieldValue(value)}
        onEnterKey={handleEnter}
        onFocus={onFocusTextField}
        value={textFieldValue}
        {...props}
      />
      <InputChips chipCollection={chipCollection} onClick={handleClick} />
    </div>
  )
}

MultiTextField.propTypes = {
  initialValues: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  name: PropTypes.string,
  onBlurTextField: PropTypes.func,
  onFocusTextField: PropTypes.func,
  onUpdateValues: PropTypes.func,
}
